<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Réparations",
          icon: "bi bi-clipboard-check-fill",
          route: "repairs-index",
        },
        {
          label: "À valider",
          icon: "bi bi-chat-left-dots-fill",
          route: "repairs-tovalidate-index",
        },
        {
          label: "Remarquées",
          icon: "bi bi-sticky-fill",
          route: "repairs-noticed-index",
        },
        {
          label: "Rapport client",
          icon: "bi bi-file-earmark-bar-graph-fill",
          route: "repairs-customer-report",
        },
        {
          label: "Nouvelle réparation",
          icon: "bi bi-bag-plus-fill",
          route: "repairs-create",
        },
      ],
    };
  },
};
</script>
